
import { Vue, Component, Watch } from "vue-property-decorator";
import common from "@/store/common/module/common";

@Component
export default class App extends Vue {
  logged = true;

  @Watch("$route", { immediate: true })
  onValueChange(to, from) {
    document.title = to.name || "DoShip";
    common.setError("");
    common.showMessage("");
    common.showWarning("");
  }
}
